import React, { useEffect, useState } from 'react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { Layout } from 'antd';
import jwtDecode from 'jwt-decode';

import ToolHeader from 'src/components/Header/toolHeader';
import Loading from 'src/components/common/Loading';
import { useQueryProxy } from 'src/operations/proxy/user';
import { USER_ME } from 'src/operations/queries/getUser';
import { isLogedIn, userInfoVar } from 'src/apollo/cache';
import { getCurrentToken } from 'src/utils';

const { Content } = Layout;

function ToolLayout({ component: Component, ...rest }) {
  const history = useHistory();
  const token = getCurrentToken();
  const [title, setTitle] = useState(0);
  const [hideHeader, setHideHeader] = useState(false);
  const [initiallyLoadedMeToken, setInitiallyLoadedMeToken] = useState(null);
  const hasCompletedInitialMeLoad = Boolean(token && initiallyLoadedMeToken === token);

  const { loading, data, refetch } = useQueryProxy(USER_ME, {
    variables: { token },
    skip: !token,
    notifyOnNetworkStatusChange: false,
    onError() {
      isLogedIn(false);
      if (history.location.pathname !== '/login') {
        history.replace('/login');
      }
    },
  });

  useEffect(() => {
    if (data?.me || (!loading && token)) {
      setInitiallyLoadedMeToken(token);
    }
  }, [data?.me, loading, token]);

  useEffect(() => {
    if (!isLogedIn() || !token) {
      if (history.location.pathname !== '/login') {
        history.replace('/login');
      }
    }
  }, [history, token]);

  useEffect(() => {
    if (data?.me) {
      userInfoVar(data.me);
    } else if (token) {
      userInfoVar(jwtDecode(token));
    }
  }, [data, token]);

  useEffect(() => {
    const checkSessionOnFocus = () => {
      const currentToken = getCurrentToken();

      if (!currentToken) {
        isLogedIn(false);
        if (history.location.pathname !== '/login') {
          history.replace('/login');
        }
        return;
      }

      refetch({ token: currentToken }).catch(() => {
        // The query's onError handler redirects to login.
      });
    };

    window.addEventListener('focus', checkSessionOnFocus);
    return () => window.removeEventListener('focus', checkSessionOnFocus);
  }, [history, refetch]);

  if (!token || !isLogedIn()) {
    return <Redirect to="/login" />;
  }

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <>
          {!hasCompletedInitialMeLoad && loading ? (
            <Loading />
          ) : (
            <Layout>
              <Layout>
                {/* {!hideHeader ? <ToolHeader title={title} /> : null} */}
                <Content style={{ margin: '0 16px' }}>
                  <Component onChangeTitle={(v) => setTitle(v)} onSetHideHeader={(v) => setHideHeader(v)} {...matchProps} {...rest} />
                </Content>
              </Layout>
            </Layout>
          )}
        </>
      )}
    />
  );
}

export default ToolLayout;
